import { ROUTE_NAME } from "@/constants/constants";

export const VAN_BAN_DI_FIELD = {
  SO_KY_HIEU: "SoKyHieu",
  TRICH_YEU: "TrichYeu",
  NGAY_TAO: "NgayTao",
  NGUOI_SOAN_THAO: "NguoiSoanThao",
  DON_VI_SOAN_THAO: "DonViSoanThao",
  NGUOI_XU_LY: "NguoiXuLy",
  NGAY_XU_LY: "NgayXuLy",
  DON_VI_NHAN_VAN_BAN: "NoiNhanVanBanBanHanh",
  LOAI_VAN_BAN_DI: "LoaiVanBanDi",
  LOAI_VAN_BAN: "LoaiVanBan",
  DO_KHAN: "DoKhan",
  VAN_BAN_TRA_LOI: "VanBanTraLoi",
  SO_KY_HIEU_VAN_BAN_TRA_LOI: "SoKyHieuVanBanTraLoi",
  DON_VI_BAN_HANH: "DonViBanHanh",
  NGAY_BAN_HANH: "NgayBanHanh",
  NOI_DUNG_CHI_DAO: "VanBanChiDaoDss",
  NGUOI_THEO_DOI_VAN_BAN: "NguoiTheoDoiVanBan",
  NGUOI_KY_DUYET: "NguoiKyDuyet",
  NGUOI_KY_VAN_BAN: "NguoiKyVanBan",
  NGUOI_KIEM_TRA_THE_THUC: "NguoiKiemTraTheThuc",
  NGUOI_CAP_SO_BAN_HANH: "NguoiCapSoBanHanh",
  FILE: "Files",
  HAN_XU_LY: "HanXuLy",
  SO_DI: "SoTTVB",
  SO_VAN_BAN: "SoVanBan",
  KY_SO: "KySo",
  LUONG: "IsLuong",
  TRANG_THAI_LIEN_THONG: 'TrangThaiLienThong',
  TRANG_THAI_VAN_BAN_XIN_SO_BO: "VanBanDi_XinSoBo_TrangThai"
};

export const VAN_BAN_DI_FORM = {
  SoKyHieuSearch: "",
  TrichYeuSearch: "",
  NgayTaoStartSearch: "",
  NgayTaoEndSearch: "",
  NguoiSoanThaoSearch: "",
  DonViSoanThaoSearch: "",
  NguoiXuLySearch: "",
  NgayXuLyStartSearch: "",
  NgayXuLyEndSearch: "",
  VanBanTraLoiSearch: "",
  SoKyHieuVanBanTraLoiSearch: "",
  DonViBanHanhSearch: "",
  NoiDungChiDaoSearch: "",
  NguoiTheoDoiVanBanSearch: "",
  NguoiKyDuyetSearch: "",
  NguoiKyVanBanSearch: "",
  NguoiKiemTraTheThucSearch: "",
  NguoiCapSoBanHanhSearch: "",
  SoTTVBSearch: "",
  IdSoVanBanFilter: null,
  KeySearch: "",
  DonViTraLaiSearch: null,
  DoKhanFilter: null,
  IsLuong: null,
  IsLaVanBanDiBanHanh: null,
  LoaiVanBanFilter: null,
  fileNameSearch: "",
  HasFile: 0,
  IsKySo: 0,
  NgayBanHanhStart: "",
  NgayBanHanhEnd: "",
  NoiNhanSearch: "",
  TrangThaiLienThongSearch: null,
};

export const MANG_VAN_BAN_DI_FIELDS = [
  {
    field: VAN_BAN_DI_FIELD.SO_DI,
    header: "Số đi",
    bodyClass: "text-right",
    keySearch: "SoTTVBSearch",

  },
  {
    field: VAN_BAN_DI_FIELD.SO_VAN_BAN,
    header: "Sổ văn bản",
    bodyClass: "text-left",
    keySearchs: "IdSoVanBanFilter",
  },
  {
    field: VAN_BAN_DI_FIELD.SO_KY_HIEU,
    header: "Số/Ký hiệu",
    keySearch: "SoKyHieuSearch",
    soHieu: true,
  },
  {
    field: VAN_BAN_DI_FIELD.LOAI_VAN_BAN,
    header: "Loại văn bản",
    keySearchs: "LoaiVanBanFilter",
    bodyClass: "text-left",
  },
  {
    field: VAN_BAN_DI_FIELD.TRICH_YEU,
    header: "Trích yếu",
    keySearch: "TrichYeuSearch",
    trichYeu: true,
  },
  {
    field: VAN_BAN_DI_FIELD.KY_SO,
    header: "Có ký số",
    bodyClass: "text-left",
    keySearchs: "IsKySo",
    classHeader: "minWidth: 100px",
  },
  {
    field: VAN_BAN_DI_FIELD.LUONG,
    header: "Có luồng",
    bodyClass: "text-left",
    keySearchs: "IsLuong",
    classHeader: "minWidth: 100px",
  },
  {
    field: VAN_BAN_DI_FIELD.NGAY_TAO,
    header: "Ngày tạo",
    bodyClass: "text-center",
    ngayTao: "true",
  },
  {
    field: VAN_BAN_DI_FIELD.TRANG_THAI_VAN_BAN_XIN_SO_BO,
    header: "Trạng thái",
    classHeader: "minWidth: 200px",
  },
  {
    field: VAN_BAN_DI_FIELD.NGUOI_SOAN_THAO,
    header: "Người soạn thảo",
    keySearch: "NguoiSoanThaoSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.DON_VI_SOAN_THAO,
    header: "Đơn vị soạn thảo",
    keySearch: "DonViSoanThaoSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.DON_VI_BAN_HANH,
    header: "Đơn vị ban hành",
    keySearch: "DonViBanHanhSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NGUOI_XU_LY,
    header: "Đơn vị xử lý văn bản chỉ đạo",
    keySearch: "NguoiXuLySearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NGAY_XU_LY,
    header: "Ngày xử lý",
    bodyClass: "text-center",
    ngayXL: "true",
  },
  {
    field: VAN_BAN_DI_FIELD.DON_VI_NHAN_VAN_BAN,
    header: "Nơi nhận",
    keySearch: "NoiNhanSearch",
    classHeader: "minWidth: 300px"
  },
  {
    field: VAN_BAN_DI_FIELD.HAN_XU_LY,
    header: "Hạn xử lý",
    bodyClass: "text-center",
  },
  {
    field: VAN_BAN_DI_FIELD.LOAI_VAN_BAN_DI,
    header: "Loại văn bản đi",
    keySearchs: "IsLaVanBanDiBanHanh",
    bodyClass: "text-left",
  },
  {
    field: VAN_BAN_DI_FIELD.DO_KHAN,
    header: "Độ khẩn",
    keySearchs: "DoKhanFilter",
    bodyClass: "text-left",
  },
  {
    field: VAN_BAN_DI_FIELD.VAN_BAN_TRA_LOI,
    header: "Văn bản trả lời",
    keySearch: "VanBanTraLoiSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.SO_KY_HIEU_VAN_BAN_TRA_LOI,
    header: "Số/Ký hiệu văn bản trả lời",
    keySearch: "SoKyHieuVanBanTraLoiSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NOI_DUNG_CHI_DAO,
    header: "Nội dung chỉ đạo",
    keySearch: "NoiDungChiDaoSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NGUOI_THEO_DOI_VAN_BAN,
    header: "Người theo dõi văn bản",
    keySearch: "NguoiTheoDoiVanBanSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NGUOI_KY_DUYET,
    header: "Người ký duyệt",
    keySearch: "NguoiKyDuyetSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NGUOI_KY_VAN_BAN,
    header: "Người ký văn bản",
    keySearch: "NguoiKyVanBanSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NGUOI_KIEM_TRA_THE_THUC,
    header: "Người kiểm tra thể thức",
    keySearch: "NguoiKiemTraTheThucSearch",
  },
  {
    field: VAN_BAN_DI_FIELD.NGUOI_CAP_SO_BAN_HANH,
    header: "Người cấp số/ban hành",
    keySearch: "NguoiCapSoBanHanhSearch",
  },
];

export const TRANG_THAI_VAN_BAN_DI = {
  TRA_CUU: "",
  CHO_TRINH_KY: 1,
  CHO_KY_DUYET: 2,
  CHO_KY_VAN_BAN: 3,
  CHO_KIEM_TRA_THE_THUC: 4,
  CHO_CAP_SO: 5,
  CHO_BAN_HANH: 6,
  DA_BAN_HANH: 7,
  DA_THU_HOI: 8,
  DA_TRA_LAI: 9,
  DA_XU_LY: 10,
  VAN_BAN_ERROR: 99,
  NOI_BO: -1,
};

export const MANG_LOC_TRANG_THAI = [
  {
    text: "Tất cả",
    value: TRANG_THAI_VAN_BAN_DI.TRA_CUU,
  },
  {
    text: "Chờ trình ký",
    value: TRANG_THAI_VAN_BAN_DI.CHO_TRINH_KY,
  },
  {
    text: "Chờ xử lý",
    value: TRANG_THAI_VAN_BAN_DI.CHO_KY_DUYET,
  },
  {
    text: "Đã xử lý",
    value: TRANG_THAI_VAN_BAN_DI.DA_XU_LY,
  },
  {
    text: "Chờ ban hành",
    value: TRANG_THAI_VAN_BAN_DI.CHO_BAN_HANH,
  },
  {
    text: "Chờ cấp số",
    value: TRANG_THAI_VAN_BAN_DI.CHO_CAP_SO,
  },
  {
    text: "Đã ban hành",
    value: TRANG_THAI_VAN_BAN_DI.DA_BAN_HANH,
  },
];

export const SO_LUONG_VB_DI = {
  CHO_TRINH_KY: "SoLuongChoTrinhKy",
  CHO_XU_LY: "SoLuongChoXuLy",
  DA_XU_LY: "SoLuongDaXuLy",
  CHO_BAN_HANH: "SoLuongChoBanHanh",
  CHO_CAP_SO: "SoLuongChoCapSo",
  CHO_BO_CAP_SO: "SoLuongChoBoCapSo",
  DA_BAN_HANH: "SoLuongDaBanHanh",
  NOI_BO: "SoLuongNoiBo",
  CHO_Y_KIEN: "SoLuongChoYKien",
  DA_CHO_Y_KIEN: "SoLuongDaChoYKien",
  DA_TRA_LAI: "SoLuongDaTraLai",
  YEU_CAU_TRA_LAI: "SoLuongYeuCauTraLai",
  BI_TRA_LAI : "SoLuongBiTraLai" ,
};

export const COT_VAN_BAN_DI_BAN_DAU = [
  VAN_BAN_DI_FIELD.SO_KY_HIEU,
  VAN_BAN_DI_FIELD.LOAI_VAN_BAN,
  VAN_BAN_DI_FIELD.TRICH_YEU,
  VAN_BAN_DI_FIELD.NGUOI_SOAN_THAO,
  VAN_BAN_DI_FIELD.NGAY_TAO,
  VAN_BAN_DI_FIELD.DON_VI_NHAN_VAN_BAN,
  //VAN_BAN_DI_FIELD.NGAY_XU_LY,
];
export const COT_VAN_BAN_DI_CHO_BO_CAP_SO_BAN_DAU = [
  VAN_BAN_DI_FIELD.SO_KY_HIEU,
  VAN_BAN_DI_FIELD.LOAI_VAN_BAN,
  VAN_BAN_DI_FIELD.TRICH_YEU,
  VAN_BAN_DI_FIELD.TRANG_THAI_VAN_BAN_XIN_SO_BO,
  VAN_BAN_DI_FIELD.NGUOI_SOAN_THAO,
  VAN_BAN_DI_FIELD.DON_VI_NHAN_VAN_BAN,
];
export const COT_VAN_BAN_DI_BAN_DAU_DA_BAN_HANH = [
  VAN_BAN_DI_FIELD.SO_KY_HIEU,
  VAN_BAN_DI_FIELD.LOAI_VAN_BAN,
  VAN_BAN_DI_FIELD.TRICH_YEU,
  VAN_BAN_DI_FIELD.KY_SO,
  VAN_BAN_DI_FIELD.NGUOI_SOAN_THAO,
  VAN_BAN_DI_FIELD.DON_VI_NHAN_VAN_BAN,
  //VAN_BAN_DI_FIELD.NGAY_XU_LY,
];

export const COT_VAN_BAN_DI_BAN_DAU_QLDS = [
  VAN_BAN_DI_FIELD.SO_DI,
  VAN_BAN_DI_FIELD.SO_VAN_BAN,
  VAN_BAN_DI_FIELD.LOAI_VAN_BAN,
  VAN_BAN_DI_FIELD.SO_KY_HIEU,
  VAN_BAN_DI_FIELD.TRICH_YEU,
];

export const DO_KHAN = {
  TAT_CA: null,
  BINH_THUONG: 1,
  KHAN: 2,
  THUONG_KHAN: 3,
  HOA_TOC: 4,
};

export const MANG_DO_KHAN = [
  {
    value: DO_KHAN.TAT_CA,
    text: "Tất cả",
  },
  {
    value: DO_KHAN.BINH_THUONG,
    text: "Bình thường",
  },
  {
    value: DO_KHAN.KHAN,
    text: "Khẩn",
  },
  {
    value: DO_KHAN.THUONG_KHAN,
    text: "Thượng khẩn",
  },
  {
    value: DO_KHAN.HOA_TOC,
    text: "Hỏa tốc",
  },
];

export const MANG_PHUONG_THUC = [
  { text: "SMS", value: "sms" },
  { text: "Email", value: "email" },
];

export const CF_MODAL_TYPE = {
  TRINH_KY: 1,
  HUY_TRINH_KY: 2,
  DUYET: 3,
  HUY_DUYET: 4,
  KY_SO_FILE: 5,
  BAN_HANH: 6,
  XOA: 7,
  ADD_QR_CODE: 8,
  XAC_NHAN_CAP_SO_VA_BAN_HANH :9 ,
  XAC_NHAN_CAP_SO : 10,
  XAC_NHAN_GUI_FILE : 11,
  XAC_NHAN_SUA_VB_DA_CAP_SO : 12,
};

export const LOAI_BAN_HANH = {
  SOAN_THAO: 0,
  KY_DUYET: 1,
  KY_VAN_BAN: 2,
  KIEM_TRA_THE_THUC: 3,
  CAP_SO_BAN_HANH: 4,
};

export const MANG_LOAI_BAN_HANH = [
  {
    value: LOAI_BAN_HANH.SOAN_THAO,
    text: "Soạn thảo",
  },
  {
    value: LOAI_BAN_HANH.KY_DUYET,
    text: "Ký duyệt",
  },
  {
    value: LOAI_BAN_HANH.KY_VAN_BAN,
    text: "Ký văn bản",
  },
  {
    value: LOAI_BAN_HANH.KIEM_TRA_THE_THUC,
    text: "Kiểm tra thể thức",
  },
  {
    value: LOAI_BAN_HANH.CAP_SO_BAN_HANH,
    text: "Cấp số ban hành",
  },
];

export const FIELD_LS_CAP_NHAT_VB_DI = [
  {
    key: "NguoiCapNhat",
    label: "Người cập nhật",
  },
  {
    key: "DonViCapNhat",
    label: "Đơn vị cập nhật",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
    tdClass: "text-center",
  },
  {
    key: "NoiDungCapNhat",
    label: "Nội dung cập nhật",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
    tdClass: "text-center",
  },
  {
    key: "Files",
    label: "File đính kèm",
  },
];

export const FIELD_LS_TRA_LAI_VB_DI = [
  {
    key: "NguoiTraLai",
    label: "Người trả lại",
  },
  {
    key: "NoiDungTraLai",
    label: "Nội dung trả lại",
  },
  {
    key: "DonViTraLai",
    label: "Đơn vị trả lại",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
    tdClass: "text-center",
  },
  {
    key: "NoiDungTraLai",
    label: "Nội dung trả lại",
  },
  {
    key: "NguoiBiTraLai",
    label: "Người bị trả lại",
  },
  {
    key: "DonViBiTraLai",
    label: "Đơn vị bị trả lại",
  },
  {
    key: "Files",
    label: "File đính kèm",
  },
];

export const FIELD_LS_THU_HOI_VB_DI = [
  {
    key: "NguoiThuHoi",
    label: "Người thu hồi",
  },
  {
    key: "NoiDungThuHoi",
    label: "Nội dung thu hồi",
  },
  {
    key: "DonViThuHoi",
    label: "Đơn vị thu hồi",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
    tdClass: "text-center",
  },
  {
    key: "NguoiBiThuHoi",
    label: "Người bị thu hồi",
  },
  {
    key: "DonViBiThuHoi",
    label: "Đơn vị bị thu hồi",
  },
  {
    key: "Files",
    label: "File đính kèm",
  },
  {
    key: "HanhDong",
    label: "Thao tác",
  },
];
export const FIELD_THEO_DOI_LIEN_THONG_VB_DI = [
  {
    key: "STT",
    label: "STT",
  },
  {
    key: "ThoiGianGui",
    label: "Thời gian gửi",
  },
  {
    key: "DonViGui",
    label: "Đơn vị gửi",
  },
  {
    key: "IntThaoTacGui",
    label: "Hành động",
  },
  {
    key: "TrangThaiGui",
    label: "Trạng thái gửi",
    tdClass: "text-center",
  },
  {
    key: "NguoiNhan",
    label: "Người nhận",
  },
  {
    key: "DonViNhan",
    label: "Đơn vị nhận",
  },
  {
    key: "ThoiGianNhan",
    label: "Thời điểm",
  },
  {
    key: "TrangThaiNhan",
    label: "Trạng thái nhận",
  },
  {
    key: "LyDo",
    label: "Lý do",
  },
  {
    key: "ChiTietLichSu",
    label: "Thao tác",
  },
];
export const DANH_SACH_LICH_SU_VB_DA_BAN_HANH = [
  {
    key: "stt",
    label: "STT",
    tdClass: "text-center",
  },
  {
    key: "TenCanBo",
    label: "Tên cán bộ",
  },
  {
    key: "TenDonVi",
    label: "Cá nhân/ Đơn vị",
  },
  {
    key: "NgayCapNhat",
    label: "Thời gian",
    tdClass: "text-center",
  },
  {
    key: "TrangThaiXuLy",
    label: "Trạng thái xử lý",
  },
  {
    key: "TrangThaiGui",
    label: "Trạng thái gửi văn bản",
  },
  {
    key: "NoiDung",
    label: "Nội dung",
  },
  {
    key: "Files",
    label: "File đính kèm",
  },
  {
    key: "ChiTietLuong",
    label: "Thao tác",
  },
];

export const FIELD_LS_HUY_DUYET_VB_DI = [
  {
    key: "CanBo",
    label: "Cán bộ",
  },
  {
    key: "NoiDungCapNhat",
    label: "Nội dung hủy duyệt",
  },
  {
    key: "DonVi",
    label: "Đơn vị",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
    tdClass: "text-center",
  },
  {
    key: "Files",
    label: "File đính kèm",
  },
];

export const LOAI_XU_LY = {
  SOAN_THAO: 0,
  KY_DUYET: 1,
  KY_VAN_BAN: 2,
  KIEM_TRA_THE_THUC: 3,
  CAP_SO_BAN_HANH: 4,
};

export const MANG_LOAI_XU_LY = [
  {
    value: LOAI_XU_LY.SOAN_THAO,
    text: "Người soạn thảo",
  },
  {
    value: LOAI_XU_LY.KY_DUYET,
    text: "Người ký duyệt",
  },
  {
    value: LOAI_XU_LY.KY_VAN_BAN,
    text: "Người ký văn bản",
  },
  {
    value: LOAI_XU_LY.KIEM_TRA_THE_THUC,
    text: "Người kiểm tra thể thức",
  },
  {
    value: LOAI_XU_LY.CAP_SO_BAN_HANH,
    text: "Người cấp số ban hành",
  },
];

export const LOAI_TRANG_THAI_LXL = {
  CHO_TRINH_KY: 1,
  DA_TRINH_KY: 2,
  CHO_DUYET: 3,
  DA_DUYET: 4,
  CHO_CAP_SO: 5,
  CHO_BAN_HANH: 6,
  DA_BAN_HANH: 7,
  TRA_LAI: 8,
  HUY_TRINH_KY: 9,
  HUY_DUYET: 10,
};

export const MANG_TRANG_THAI_LXL = [
  {
    value: LOAI_TRANG_THAI_LXL.CHO_TRINH_KY,
    text: "Chờ trình ký",
  },
  {
    value: LOAI_TRANG_THAI_LXL.DA_TRINH_KY,
    text: "Đã trình ký",
  },
  {
    value: LOAI_TRANG_THAI_LXL.CHO_DUYET,
    text: "Chờ duyệt",
  },
  {
    value: LOAI_TRANG_THAI_LXL.DA_DUYET,
    text: "Đã duyệt",
  },
  {
    value: LOAI_TRANG_THAI_LXL.CHO_CAP_SO,
    text: "Chờ cấp số",
  },
  {
    value: LOAI_TRANG_THAI_LXL.CHO_BAN_HANH,
    text: "Chờ ban hành",
  },
  {
    value: LOAI_TRANG_THAI_LXL.DA_BAN_HANH,
    text: "Đã ban hành",
  },
  {
    value: LOAI_TRANG_THAI_LXL.TRA_LAI,
    text: "Trả lại",
  },
  {
    value: LOAI_TRANG_THAI_LXL.HUY_TRINH_KY,
    text: "Huỷ trình ký",
  },
  {
    value: LOAI_TRANG_THAI_LXL.HUY_DUYET,
    text: "Huỷ duyệt",
  },
];

export const TRANG_THAI_BANG_LICH_SU = {
  TRINH_KY: 0,
  DUYET: 1,
  HUY_DUYET: 2,
  THU_HOI: 3,
  TRA_LAI: 4,
  CAP_SO: 5,
  BAN_HANH: 6,
  THU_HOI_VAN_BAN_DI_DA_BAN_HANH: 7,
  HUY_TRINH_KY: 8,
  TRINH_KY_TIEP_THEO: 9,
  KHOI_TAO_VAN_BAN: 10,
  CAP_NHAT_VAN_BAN: 11,
  XAC_NHAN_THU_HOI_VAN_BAN_BAN_HANH: 13,
};

export const MANG_TRANG_THAI_BANG_LICH_SU = [
  {
    value: TRANG_THAI_BANG_LICH_SU.TRINH_KY,
    text: "Trình ký",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.DUYET,
    text: "Duyệt",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.HUY_DUYET,
    text: "Hủy duyệt",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.THU_HOI,
    text: "Thu hồi",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.TRA_LAI,
    text: "Trả lại",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.CAP_SO,
    text: "Cấp số",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.BAN_HANH,
    text: "Ban hành",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.THU_HOI_VAN_BAN_DI_DA_BAN_HANH,
    text: "Thu hồi văn bản đi đã ban hành",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.HUY_TRINH_KY,
    text: "Hủy trình ký",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.TRINH_KY_TIEP_THEO,
    text: "Trình ký tiếp theo",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.KHOI_TAO_VAN_BAN,
    text: "Khởi tạo văn bản",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.CAP_NHAT_VAN_BAN,
    text: "Cập nhật văn bản",
  },
  {
    value: TRANG_THAI_BANG_LICH_SU.XAC_NHAN_THU_HOI_VAN_BAN_BAN_HANH,
    text: "Xác nhận thu hồi văn bản ban hành",
  }
];

export const DANH_SACH_COT_EXPORT_VAN_BAN_DI = [
  {
    Key: "SoTTVB",
    Value: "Số đi",
    Width: 15,
  },
  {
    Key: "SoVanBan",
    Value: "Sổ văn bản",
    Width: 15,
  },
  {
    Key: "SoKyHieu",
    Value: "Số/Ký hiệu",
    Width: 15,
  },
  {
    Key: "TrichYeu",
    Value: "Trích yếu",
    Width: 20,
  },
  {
    Key: "NgayTao",
    Value: "Ngày tạo",
    Width: 15,
  },
  {
    Key: "NguoiSoanThao",
    Value: "Người soạn thảo",
    Width: 15,
  },
  {
    Key: "DonViSoanThao",
    Value: "Đơn vị soạn thảo",
    Width: 25,
  },
  {
    Key: "NguoiXuLy",
    Value: "Đơn vị xử lý văn bản chỉ đạo",
    Width: 25,
  },
  {
    Key: "NgayXuLy",
    Value: "Ngày xử lý",
    Width: 15,
  },
  {
    Key: "HanXuLy",
    Value: "Hạn xử lý",
    Width: 15,
  },
  {
    Key: "LoaiVanBanDi",
    Value: "Loại văn bản đi",
    Width: 15,
  },
  {
    Key: "LoaiVanBan",
    Value: "Loại văn bản",
    Width: 15,
  },
  {
    Key: "DoKhan",
    Value: "Độ khẩn",
    Width: 15,
  },
  {
    Key: "VanBanTraLoi",
    Value: "Văn bản trả lời",
    Width: 15,
  },
  {
    Key: "SoKyHieuVanBanTraLoi",
    Value: "Số/Ký hiệu văn bản trả lời",
    Width: 15,
  },
  {
    Key: "DonViBanHanh",
    Value: "Đơn vị ban hành",
    Width: 15,
  },
  {
    Key: "NoiDungChiDao",
    Value: "Nội dung chỉ đạo",
    Width: 15,
  },
  {
    Key: "NguoiTheoDoiVanBan",
    Value: "Người theo dõi văn bản",
    Width: 15,
  },
  {
    Key: "NguoiKyDuyet",
    Value: "Người ký duyệt",
    Width: 15,
  },
  {
    Key: "NguoiKyVanBan",
    Value: "Người ký văn bản",
    Width: 15,
  },
  {
    Key: "NguoiKiemTraTheThuc",
    Value: "Người kiểm tra thể thức",
    Width: 15,
  },
  {
    Key: "NguoiCapSoBanHanh",
    Value: "Người cấp số/ban hành",
    Width: 15,
  },
];

export const GIA_TRI_TRANG_THAI_GUI_VA_XU_LY = {
  CHUA_DONG_BO_DUOC: 0,
  DA_DEN: 1,
  TU_CHOI_TIEP_NHAN: 2,
  DA_TIEP_NHAN: 3,
  PHAN_CONG: 4,
  DANG_XU_LY: 5,
  HOAN_THANH: 6,
  TRA_LAI_TU_VAN_BAN_DEN: 7,
  CHO_VAO_SO: 8,
  CHO_XU_LY: 9,
  THANH_CONG: 10,
  KHONG_THANH_CONG: 11,
};

export const MANG_TRANG_THAI_GUI_VA_XU_LY = [
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.CHUA_DONG_BO_DUOC,
    text: "Chưa đồng bộ được",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.DA_DEN,
    text: "Đã đến",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.TU_CHOI_TIEP_NHAN,
    text: "Từ chối tiếp nhận",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.DA_TIEP_NHAN,
    text: "Đã tiếp nhận",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.PHAN_CONG,
    text: "Phân công",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.DANG_XU_LY,
    text: "Đang xử lý",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.HOAN_THANH,
    text: "Hoàn thành",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.TRA_LAI_TU_VAN_BAN_DEN,
    text: "Trả lại từ văn bản đến",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.CHO_VAO_SO,
    text: "Chờ vào sổ",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.CHO_XU_LY,
    text: "Chờ xử lý",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.THANH_CONG,
    text: "Thành công",
  },
  {
    value: GIA_TRI_TRANG_THAI_GUI_VA_XU_LY.KHONG_THANH_CONG,
    text: "Không thành công",
  },
];

export const TRANG_THAI_VB_DI_MENU = {
  CHO_TRINH_KY: 1,
  CHO_XU_LY: 2,
  DA_XU_LY: 3,
  DA_TRA_LAI: 4,
  CHO_Y_KIEN: 5,
  DA_CHO_Y_KIEN: 6,
  CHO_CAP_SO: 7,
  CHO_BAN_HANH: 8,
  DA_BAN_HANH: 9,
  NOI_BO: 10,
  TRA_CUU: 11,
  BI_TRA_LAI: 12,
};

export const MANG_TRANG_THAI_VB_DI_MENU = [
  {
    value: TRANG_THAI_VB_DI_MENU.CHO_TRINH_KY,
    text: ROUTE_NAME.VAN_BAN_DI.CHO_TRINH_KY,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.CHO_XU_LY,
    text: ROUTE_NAME.VAN_BAN_DI.CHO_XU_LY,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.DA_XU_LY,
    text: ROUTE_NAME.VAN_BAN_DI.DA_XU_LY,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.DA_TRA_LAI,
    text: ROUTE_NAME.VAN_BAN_DI.DA_TRA_LAI,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.CHO_Y_KIEN,
    text: ROUTE_NAME.VAN_BAN_DI.CHO_Y_KIEN,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.DA_CHO_Y_KIEN,
    text: ROUTE_NAME.VAN_BAN_DI.DA_CHO_Y_KIEN,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.CHO_CAP_SO,
    text: ROUTE_NAME.VAN_BAN_DI.CHO_CAP_SO,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.CHO_BAN_HANH,
    text: ROUTE_NAME.VAN_BAN_DI.CHO_BAN_HANH,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.DA_BAN_HANH,
    text: ROUTE_NAME.VAN_BAN_DI.DA_BAN_HANH,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.NOI_BO,
    text: ROUTE_NAME.VAN_BAN_DI.NOI_BO,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.TRA_CUU,
    text: ROUTE_NAME.VAN_BAN_DI.TRA_CUU,
  },
  {
    value: TRANG_THAI_VB_DI_MENU.BI_TRA_LAI,
    text: ROUTE_NAME.VAN_BAN_DI.BI_TRA_LAI,
  },
];

export const LOAI_DU_LIEU = {
  TAT_CA: null,
  EOFFICE: 1,
  MOI: 2,
  MPI: 3,
};

export const MANG_LOAI_DU_LIEU = [
  {
    text: "Tất cả",
    value: LOAI_DU_LIEU.TAT_CA,
  },
  {
    text: "Dữ liệu mới tạo trên hệ thống",
    value: LOAI_DU_LIEU.MOI,
  },
  {
    text: "Dữ liệu cũ từ EOffice",
    value: LOAI_DU_LIEU.EOFFICE,
  },
  {
    text: "Dữ liệu MPI",
    value: LOAI_DU_LIEU.MPI,
  },
];

export function closeIfNotFound(message, vm, route) {
  if ((message || "").toLowerCase().includes("bản ghi không tồn tại")) {
    vm.$router.push({
      path: `${ROUTE_NAME.VAN_BAN_DI.NAME}${vm.$route.params.route || route}`,
    });
  }
}
